module.exports = __webpack_public_path__ + "static/img/aveu_logo.b63d5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/aveu_logo.png
// module id = aI9A
// module chunks = 6